var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8IncompletePrice(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "1.1rem",
    height: "1.1rem",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-24.38095,-24.38095h304.7619v304.7619h-119.82364c3.73275,-5.01017 5.91283,-11.28893 5.91283,-18.2089c0,-3.85753 -0.77151,-7.71507 -3.08603,-11.5726l-68.66411,-123.4411c-6.17205,-12.34411 -16.20164,-20.05918 -28.54575,-20.05918c-13.88712,0 -23.91671,10.8011 -28.54575,20.05918l-62.00945,111.47765z",
    id: "overlayBgMask",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.36,15.36) scale(0.88,0.88)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-1)",
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.48,-20.48) scale(5.12,5.12)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,2c-12.6907,0 -23,10.3093 -23,23c0,12.69071 10.3093,23 23,23c12.69071,0 23,-10.30929 23,-23c0,-12.6907 -10.30929,-23 -23,-23zM25,4c11.60982,0 21,9.39018 21,21c0,11.60982 -9.39018,21 -21,21c-11.60982,0 -21,-9.39018 -21,-21c0,-11.60982 9.39018,-21 21,-21zM26.40039,12.69922c-2.7,0 -8.10117,1.20039 -9.70117,9.40039h-1.69922l-0.59961,1.5h2.19922c-0.1,0.3 -0.09961,1.10078 -0.09961,1.30078v0.69922h-1.5l-0.59961,1.5h2.19922c1.2,9 6.79961,10.09961 9.59961,10.09961c2.3,0 4.20156,-0.69922 6.10156,-2.19922v-2.59961c-2.8,2.9 -4.70039,2.90039 -5.90039,2.90039c-2.2,0 -6.5,-0.90117 -7.5,-8.20117h9.5l0.59961,-1.5h-10.30078v-0.5c0,-0.5 0.00156,-0.9 0.10156,-1.5h10.79883l0.59961,-1.5h-11.19922c1.3,-6.6 5.30039,-7.40039 7.40039,-7.40039c2.1,0 3.90039,0.80156 5.40039,2.60156l0.89844,-2c-1.4,-1.7 -3.49883,-2.60156 -6.29883,-2.60156z"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "var(--error-dark-color)",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18.69151,122.52932) scale(7.71507,7.71507)",
    id: "overlay"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    fontFamily: "Inter, apple-system, BlinkMacSystemFont, \"Helvetica Neue\", \"Segoe UI\", \"Fira Sans\", Roboto, Oxygen, Ubuntu, \"Droid Sans\", Arial, sans-serif",
    fontWeight: 400,
    fontSize: 16,
    textAnchor: "start",
    visibility: "hidden"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Android_x5F_4",
    fontFamily: "Inter, apple-system, BlinkMacSystemFont, \"Helvetica Neue\", \"Segoe UI\", \"Fira Sans\", Roboto, Oxygen, Ubuntu, \"Droid Sans\", Arial, sans-serif",
    fontWeight: 400,
    fontSize: 16,
    textAnchor: "start",
    visibility: "hidden"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Android_x5F_5",
    fontFamily: "Inter, apple-system, BlinkMacSystemFont, \"Helvetica Neue\", \"Segoe UI\", \"Fira Sans\", Roboto, Oxygen, Ubuntu, \"Droid Sans\", Arial, sans-serif",
    fontWeight: 400,
    fontSize: 16,
    textAnchor: "start",
    visibility: "hidden"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Windows_x5F_8",
    fontFamily: "Inter, apple-system, BlinkMacSystemFont, \"Helvetica Neue\", \"Segoe UI\", \"Fira Sans\", Roboto, Oxygen, Ubuntu, \"Droid Sans\", Arial, sans-serif",
    fontWeight: 400,
    fontSize: 16,
    textAnchor: "start",
    visibility: "hidden"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Windows_x5F_10",
    fontFamily: "Inter, apple-system, BlinkMacSystemFont, \"Helvetica Neue\", \"Segoe UI\", \"Fira Sans\", Roboto, Oxygen, Ubuntu, \"Droid Sans\", Arial, sans-serif",
    fontWeight: 400,
    fontSize: 16,
    textAnchor: "start",
    visibility: "hidden"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color",
    fontFamily: "Inter, apple-system, BlinkMacSystemFont, \"Helvetica Neue\", \"Segoe UI\", \"Fira Sans\", Roboto, Oxygen, Ubuntu, \"Droid Sans\", Arial, sans-serif",
    fontWeight: 400,
    fontSize: 16,
    textAnchor: "start",
    visibility: "hidden"
  }), /*#__PURE__*/React.createElement("g", {
    id: "IOS",
    fontFamily: "Inter, apple-system, BlinkMacSystemFont, \"Helvetica Neue\", \"Segoe UI\", \"Fira Sans\", Roboto, Oxygen, Ubuntu, \"Droid Sans\", Arial, sans-serif",
    fontWeight: 400,
    fontSize: 16,
    textAnchor: "start",
    visibility: "hidden"
  }), /*#__PURE__*/React.createElement("g", {
    id: "IOS_copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8,15c0.1,0 0.2,0.1 0.2,0.2v1.6c0,0.1 -0.1,0.2 -0.2,0.2h-1.6c-0.1,0 -0.2,-0.1 -0.2,-0.2v-1.6c0,-0.1 0.1,-0.2 0.2,-0.2zM10.2,7c-0.1,0 -0.2,0.1 -0.2,0.2v5.6c0,0.1 0.1,0.2 0.2,0.2h1.6c0.1,0 0.2,-0.1 0.2,-0.2v-5.6c0,-0.1 -0.1,-0.2 -0.2,-0.2zM22,18.1c0,-0.2 0,-0.3 -0.1,-0.5l-9,-16c-0.2,-0.4 -0.8,-1.6 -1.9,-1.6c-1.1,0 -1.7,1.2 -1.9,1.5l-8.9,16.1c-0.1,0.1 -0.1,0.3 -0.1,0.5c0,1 0.9,1.9 1.9,1.9h18.1c1,0 1.9,-0.8 1.9,-1.9zM10.9,2.4c0,0 0.1,-0.1 0.1,-0.2c0,0.1 0.1,0.2 0.1,0.2l8.7,15.6h-17.5z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8IncompletePrice);
export default __webpack_public_path__ + "static/media/icons8-incompletePrice.4d2232a712f248a48531e9008ca71bdc.svg";
export { ForwardRef as ReactComponent };